// DPO / megfelelőségi szabályok – ugyanaz a szabály, mint a szerveren (worker/core/compliance.js):
// (oldal, '*') = oldal szintű alapértelmezés, (oldal, pontszám) = alpont szintű felülírás.
export const PAGE_LEVEL = '*';

export interface DpoRule {
  page_id: number;
  pont: string;
  is_required_data: number;
  is_required_attachment: number;
  legal_notes?: string;
}

export const ruleKey = (pageId: number, pont: string) => `${Number(pageId)}|${String(pont ?? '').trim()}`;

export function buildRuleMap(rows: DpoRule[] = []): Record<string, DpoRule> {
  const m: Record<string, DpoRule> = {};
  for (const r of rows) if (r && r.page_id) m[ruleKey(r.page_id, r.pont || PAGE_LEVEL)] = r;
  return m;
}

export function effectiveRule(map: Record<string, DpoRule>, pageId: number, pont?: string | null): DpoRule | null {
  const p = String(pont ?? '').trim();
  return (p && map[ruleKey(pageId, p)]) || map[ruleKey(pageId, PAGE_LEVEL)] || null;
}
